module.exports = __webpack_public_path__ + "static/google-play-b804194d1143800444d89b5873805086.svg";